import React from 'react';
import { Calendar } from 'primereact/calendar';

interface LectureTimePickerProps {
  startTime: Date;
  endTime: Date;
  onStartTimeChange: (time: Date) => void;
  onEndTimeChange: (time: Date) => void;
}

export const LectureTimePicker: React.FC<LectureTimePickerProps> = ({
  startTime,
  endTime,
  onStartTimeChange,
  onEndTimeChange,
}) => {
  const handleStartTimeChange = (newTime: Date | null) => {
    if (!newTime) return;

    // Keep the original date, only update the time
    const updatedStartTime = new Date(startTime);
    updatedStartTime.setHours(newTime.getHours());
    updatedStartTime.setMinutes(newTime.getMinutes());
    updatedStartTime.setSeconds(0);
    updatedStartTime.setMilliseconds(0);

    onStartTimeChange(updatedStartTime);
  };

  const handleEndTimeChange = (newTime: Date | null) => {
    if (!newTime) return;

    // Keep the original date, only update the time
    const updatedEndTime = new Date(endTime);
    updatedEndTime.setHours(newTime.getHours());
    updatedEndTime.setMinutes(newTime.getMinutes());
    updatedEndTime.setSeconds(0);
    updatedEndTime.setMilliseconds(0);

    onEndTimeChange(updatedEndTime);
  };

  return (
    <div
      style={{
        marginTop: '16px',
        marginBottom: '16px',
        display: 'flex',
        flexDirection: 'row',
        gap: '16px',
        alignItems: 'center',
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
        <label style={{ fontWeight: 'bold' }}>זמן התחלה</label>
        <Calendar
          value={startTime}
          onChange={(e) => handleStartTimeChange(e.value as Date)}
          panelStyle={{
            direction: 'ltr',
          }}
          timeOnly
          hourFormat="24"
          placeholder="בחר זמן התחלה"
        />
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
        <label style={{ fontWeight: 'bold' }}>זמן סיום</label>
        <Calendar
          value={endTime}
          onChange={(e) => handleEndTimeChange(e.value as Date)}
          panelStyle={{
            direction: 'ltr',
          }}
          timeOnly
          hourFormat="24"
          placeholder="בחר זמן סיום"
        />
      </div>
    </div>
  );
};
